import { render, staticRenderFns } from "./BarChartContainer.vue?vue&type=template&id=b8fbe368&"
import script from "./BarChartContainer.vue?vue&type=script&lang=js&"
export * from "./BarChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./BarChartContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports